import { deployTag } from '$lib/config';

let staleBuild = false;
let checkInFlight = false;

export const isStaleBuild = (): boolean => staleBuild;

/**
 * Whether this tab still runs the deployed build. Activation and rollback both
 * copy a `<tag>.html` over the served `404.html` (`tools/cloud/deploy.sh`), so it
 * always names the live deploy. Match `/<tag>/_app/` whole: `DEPLOY_TAG` is
 * `git describe`, so a later deploy extends it to `<tag>-<n>-g<sha>`.
 */
export const refreshStaleBuild = async (): Promise<void> => {
  if (deployTag === undefined || staleBuild || checkInFlight) {
    return;
  }
  checkInFlight = true;
  try {
    const response = await fetch('/404.html', { cache: 'no-store' });
    if (response.ok) {
      staleBuild = !(await response.text()).includes(`/${deployTag}/_app/`);
    }
  } catch {
    // No verdict; ask again next time.
  } finally {
    checkInFlight = false;
  }
};
